import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

const FAQS = [
  { q: "Is it really free?", a: "Yes. Job seekers never pay a cent — not to apply, not to get matched, not when you're hired. Employers cover our fees." },
  { q: "Are these jobs actually remote?", a: "Every role we list is remote-friendly and open to US residents. Some state-specific roles simply ask that you live in that state for payroll and tax reasons." },
  { q: "Do I need experience?", a: "No. We have entry-level roles (customer support, payroll clerk, help desk, admin) with training, all the way up to manager and senior positions." },
  { q: "Do I need a CV to apply?", a: "Not to start. Your name, email, phone and state are enough for a recruiter to reach out. A CV helps you get matched faster, and you can add it anytime." },
  { q: "How fast will I hear back?", a: "Our team reviews every application and reaches out to strong matches within 2 business days — by email or phone." },
  { q: "Who are the employers?", a: "US companies in our vetted network across payroll, finance, HR, IT, legal, marketing, sales, operations and more. We introduce you directly." },
];

export default function FaqSection() {
  return (
    <section className="py-16 md:py-24 bg-white" data-testid="home-faq">
      <div className="max-w-7xl mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <div className="text-[11px] tracking-[0.25em] uppercase text-[#0d7a55] font-bold">Straight answers</div>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0F2A1F] leading-tight">Sounds too good? Fair question.</h2>
        </div>
        <Accordion type="single" collapsible defaultValue="faq-0" className="lg:col-span-8">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`faq-${i}`} className="border-[#0F2A1F]/10">
              <AccordionTrigger className="text-left text-base md:text-lg font-semibold text-[#0F2A1F] py-5 hover:no-underline" data-testid={`faq-trigger-${i}`}>{f.q}</AccordionTrigger>
              <AccordionContent className="text-[15px] text-[#0F2A1F]/70 leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
